import React from "react";
import axios from "axios";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

// Utilidades del flujo de gastos en 3 pasos (Requisición -> Orden -> Gasto).
// El backend vive en SauverBack/controllers/FlujoGastosController.js.
const BASE = process.env.REACT_APP_URL_API_V1;
const conToken = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

export const api = {
  get: (ruta) => axios.get(`${BASE}${ruta}`, conToken()).then((r) => r.data),
  post: (ruta, body) => axios.post(`${BASE}${ruta}`, body, conToken()).then((r) => r.data),
  patch: (ruta, body = {}) => axios.patch(`${BASE}${ruta}`, body, conToken()).then((r) => r.data),
};

export const mensajeError = (e) => e?.response?.data?.message || e?.message || "Error desconocido";

export const hoy = () => moment().format("YYYY-MM-DD");
export const haceDias = (n) => moment().subtract(n, "days").format("YYYY-MM-DD");

export const dinero = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(n) || 0);
export const numero = (n) => new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(Number(n) || 0);

export const nombreUsuario = (u) => (u && u[0] ? `${u[0].nombre || ""} ${u[0].apellido || ""}`.trim() : "");
export const primero = (arr, campo = "name") => (arr && arr[0] ? arr[0][campo] : "");

const COLORES = {
  "Por autorizar": ["#fef3c7", "#92400e"],
  Autorizada: ["#dbeafe", "#1e40af"],
  Rechazada: ["#fee2e2", "#991b1b"],
  Ordenada: ["#ede9fe", "#5b21b6"],
  "Pagada parcial": ["#ffedd5", "#9a3412"],
  Pagada: ["#dcfce7", "#166534"],
  Cancelada: ["#e5e7eb", "#374151"],
  Entrada: ["#dcfce7", "#166534"],
  Salida: ["#fee2e2", "#991b1b"],
};

export function Estado({ valor }) {
  const [fondo, texto] = COLORES[valor] || ["#f1f5f9", "#334155"];
  return (
    <span
      style={{
        background: fondo,
        color: texto,
        padding: "2px 10px",
        borderRadius: 999,
        fontSize: "0.72rem",
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {valor}
    </span>
  );
}

// Bloque de firmas al final de un PDF
function firmas(doc, etiquetas) {
  const alto = doc.internal.pageSize.getHeight();
  let y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : 60) + 30;
  if (y + 15 > alto - 10) {
    doc.addPage();
    y = 40;
  }
  doc.setFontSize(10);
  const ancho = 70;
  etiquetas.forEach((e, i) => {
    const x = 20 + i * 90;
    doc.line(x, y, x + ancho, y);
    doc.text(e, x + ancho / 2, y + 5, { align: "center" });
  });
}

export function pdfRequisicion({ requisicion, renglones }) {
  const doc = new jsPDF("portrait", "mm", "a4", true);
  const logo = new Image();
  logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(logo, "png", 150, 10, 40, 27);
  doc.setFontSize(16);
  doc.text(`Requisición de gasto # ${requisicion.idRequisicionGastos}`, 15, 20);
  doc.setFontSize(10);
  doc.text(`Fecha: ${requisicion.fecha}`, 15, 28);
  doc.text(`Solicita: ${primero(requisicion.solicitantes)}`, 15, 33);
  doc.text(`Estado: ${requisicion.status}`, 15, 38);
  doc.text(`Observaciones: ${requisicion.observaciones || "NA"}`, 15, 43);
  doc.autoTable({
    head: [["Insumo", "Unidad", "Cantidad", "Observaciones"]],
    body: renglones.map((r) => [primero(r.insumos, "nombre"), primero(r.insumos, "unidad"), numero(r.cantidad), r.observaciones || ""]),
    startY: 50,
    theme: "grid",
    headStyles: { fillColor: ["#3154A0"] },
  });
  firmas(doc, ["Solicitó", "Autorizó"]);
  window.open(doc.output("bloburl"), "_blank");
}

export function pdfOrden({ orden, renglones }) {
  const doc = new jsPDF("portrait", "mm", "a4", true);
  const logo = new Image();
  logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(logo, "png", 150, 10, 40, 27);
  doc.setFontSize(16);
  doc.text(`Orden de gasto # ${orden.idOrdenGastos}`, 15, 20);
  doc.setFontSize(10);
  doc.text(`Fecha: ${orden.fecha}`, 15, 28);
  doc.text(`Proveedor: ${primero(orden.proveedoresGastos, "nombre")}`, 15, 33);
  doc.text(`Requisición: ${orden.requisicionesGastos && orden.requisicionesGastos[0] ? orden.requisicionesGastos[0].idRequisicionGastos : "NA"}`, 15, 38);
  doc.text(`Solicita: ${primero(orden.solicitantes)}`, 15, 43);
  doc.text(`Estado: ${orden.status}`, 15, 48);
  doc.autoTable({
    head: [["Insumo", "Cantidad", "Precio", "Total"]],
    body: renglones.map((r) => [r.detalle, numero(r.cantidad), dinero(r.precio), dinero(r.total)]),
    foot: [
      ["", "", "Subtotal", dinero(orden.subtotal)],
      ["", "", `IVA ${orden.impuestos || 0}%`, dinero(orden.iva)],
      ["", "", "Total", dinero(orden.total)],
    ],
    showFoot: "lastPage",
    startY: 55,
    theme: "grid",
    headStyles: { fillColor: ["#3154A0"] },
    footStyles: { fillColor: ["#3154A0"] },
  });
  firmas(doc, ["Elaboró", "Autorizó"]);
  window.open(doc.output("bloburl"), "_blank");
}
